import React, {Fragment} from 'react';
import {Flex, Form, Submit, Textarea, Button, NoWrap} from 'components';
import {api, useToggle} from 'helpers';
import {store} from 'store';

export function CancelSubscription({ user, deleteAccount, popup }) {
  const [ proceed, setProceed ] = useToggle();
  const values = {
    popup,
    user,
    deleteAccount,
  }
  return (
    <Form initialValues={values} onSubmit={proceed ? decline : accept}>
      <h2>Delete { deleteAccount ? 'Account' : 'Subscription' }</h2>

      { !proceed &&
        <Fragment>
          <p>
            We would like to offer you a special <b className="lead">40%</b> discount on all future payments,
            <NoWrap> if you chose to keep </NoWrap>
            your subscription and answer this question:
          </p>
          <p><Textarea isDarker minRows="7" placeholder="What can we do to make the program more valuable and useful for you?" name="reason" /></p>
          <Flex className="medium-spacing" right>
            <Submit>
              {[ `Yes, keep ${deleteAccount ? 'account' : 'subscription'}`, 'Submitting..' ]}
            </Submit>
            <Button onClick={setProceed} className="danger">
              No, cancel { deleteAccount ? 'account' : 'subscription' }
            </Button>
          </Flex>
        </Fragment>
      }

      { proceed &&
        <Fragment>
          <p><Textarea isDarker minRows="7" placeholder="What can we do to make the program more valuable and useful for you?" name="reason" /></p>
          <p className="medium-spacing text-right">
            <Submit className="danger">
              {[ `Delete ${deleteAccount ? 'account' : 'subscription'}`, 'Deleting..' ]}
            </Submit>
          </p>
        </Fragment>
      }
    </Form>
  );
}

function ThankYou({ popup }) {
  return (
    <Fragment>
      <h3>Thank you for your feedback!</h3>
      <p>We really appreciate your continued trust and support.</p>
      <p>We will apply the special discount to all your future payments.</p>
      <p><Button primary onClick={popup.close}>Ok</Button></p>
    </Fragment>
  );
}

async function accept({ reason, user, popup }) {
  try {
    await api('/contact-us/', {
      type: 'support-request',
      email: user.email,
      comment: `The user was going to cancel subscription but decided to accept the 40% discount offer and stayed'. Reason: ${reason || 'not specified'}`,
    });
    popup.redirect(ThankYou)();
  } catch (error) {
    store.dispatch({
      type: 'UI_ERROR',
      errorMessage: 'Something went wrong. Please contact our support directly.',
      error,
    });
  }
}

async function decline({ reason, user, deleteAccount, popup }) {
  try {
    await api('/start-payment/', { productCode: 'Free' });
    await api('/contact-us/', {
      type: 'support-request',
      email: user.email,
      comment: `The user has canceled subscription via web. Reason: ${reason || 'not specified'}`
    });
  } catch(error) {
    store.dispatch({
      type: 'UI_NOTIFICATION',
      errorMessage: 'Server is not responding. Please try again later.',
      error,
    });
  }
  if (deleteAccount) {
    store.dispatch({
      type: 'UI_REDIRECT',
      historyPush: '/settings/delete-account/'
    });
  } else {
    store.dispatch({
      type: 'SERVER_READ',
      notification: 'Your subscription has been canceled!'
    });
  }
  popup.close();
}
